import React from "react";
import { PUZZLE_MIN_LEVEL, PUZZLE_MAX_LEVEL } from "./gameUtils";

const F = { fontFamily: "'Fredoka', sans-serif" };

/**
 * Adaptive-difficulty chips (mirrors iOS): the puzzle auto-sizes to the child
 * (the wand), but these let them pick a grid directly. A manual pick just
 * re-seeds the adaptive baseline.
 */
const PuzzleDifficultySelector = ({ level, onSelect, disabled }) => {
  const levels = [];
  for (let l = PUZZLE_MIN_LEVEL; l <= PUZZLE_MAX_LEVEL; l += 1) levels.push(l);

  return (
    <div
      className="mx-auto flex w-fit items-center gap-1.5 rounded-full bg-white px-3 py-1.5"
      style={{ boxShadow: "0 3px 12px rgba(11,26,51,0.07)" }}
    >
      <span className="mr-0.5 text-base" aria-hidden style={{ color: "#189970" }}>
        ✦
      </span>
      {levels.map((l) => {
        const active = level === l;
        return (
          <button
            key={l}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(l)}
            className="rounded-full px-3 py-2 text-sm transition-all duration-200"
            style={{
              ...F,
              fontWeight: 700,
              minWidth: 46,
              color: active ? "#FFFFFF" : "#66778F",
              background: active
                ? "linear-gradient(135deg, #38BD87 0%, #189970 100%)"
                : "rgba(102,120,143,0.08)",
              boxShadow: active ? "0 3px 8px rgba(24,153,112,0.3)" : "none",
              opacity: disabled ? 0.7 : 1,
            }}
          >
            {l}×{l}
          </button>
        );
      })}
    </div>
  );
};

export default PuzzleDifficultySelector;
